const styles = (theme) => ({
  bar: {
    padding: theme.spacing(1.5, 0),
    marginBottom: theme.spacing(1),
    gap: theme.spacing(1),
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
    width: '100%',
    marginBottom: theme.spacing(0.5),
  },
  legendLabel: {
    marginRight: theme.spacing(0.5),
  },
  summary: {
    marginRight: theme.spacing(2),
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  hint: {
    marginRight: theme.spacing(2),
    color: theme.palette.text.secondary,
    flex: 1,
    minWidth: 200,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
});

export default styles;
